/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const NavFreeTrial = ({ className, majesticonsOpen = "/img/majesticons-open-line.png" }) => {
  return (
    <div className={`nav-free-trial ${className}`}>
      <div className="text-wrapper-2">Free Trial</div>
      <img className="majesticons-open" alt="Majesticons open" src={majesticonsOpen} />
    </div>
  );
};

NavFreeTrial.propTypes = {
  majesticonsOpen: PropTypes.string,
};
